export default __webpack_public_path__ + "static/media/Background_00155.f2f3e720.png";